module.exports = __webpack_public_path__ + "static/media/LoadingScreen.2389008a.png";